import { render, staticRenderFns } from "./ToTvsConfigCard.vue?vue&type=template&id=38993403&"
import script from "./ToTvsConfigCard.vue?vue&type=script&lang=ts&"
export * from "./ToTvsConfigCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports